import React, { ReactNode } from "react";
import { Collapse, CollapseProps, Row } from "antd";
import { Plus2Icon } from "@/icons/primary";
import { BemHelper } from "../../utils/BemHelper";
import classNames from "classnames";
import { ThemeFontVariant } from "../types";
import { THEME_FONT_VARIANTS } from "../constants";
import { useActiveBreakpoints } from "@/utils/useActiveBreakpoints";

const { Panel } = Collapse;

export type CtCollapseProps = {
  title: ReactNode;
  opened?: boolean;
  children: React.ReactNode;
  fontVariant?: ThemeFontVariant;
} & CollapseProps;

const bem = new BemHelper("ct-collapse");

function CtCollapse({ title, children, opened, fontVariant }: CtCollapseProps) {
  const { activeBreakpoints } = useActiveBreakpoints();

  return (
    <Collapse
      defaultActiveKey={opened ? ["1"] : ["2"]}
      className={classNames(
        bem.block(),
        bem.modifier(fontVariant || THEME_FONT_VARIANTS.FONT_VARIANT_1),
        !activeBreakpoints.md && bem.modifier("mobile"),
      )}
      expandIcon={({ isActive }) => (
        <div>
          <Plus2Icon style={{ transform: `rotate(${isActive ? 45 : 0}deg)`, transition: "0.3s" }} />
        </div>
      )}
      expandIconPosition='end'
    >
      <Panel
        header={
          <>
            <Row align='middle'>{title}</Row>
          </>
        }
        key='1'
        forceRender
      >
        {children}
      </Panel>
    </Collapse>
  );
}

CtCollapse.defaultProps = {
  title: "Collapsible Panel Title",
  opened: false,
  children: <div>test</div>,
};

export default CtCollapse;
